import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

import { EMPTY_OBJECT } from '@e-socna/empty';

import {
  PATH_RESOLVABLE_SERVICE_DEFAULT,
  PATH_RESOLVABLE_SERVICES,
} from '../../app/constants/paths.constant';
import { Breadcrumbs } from '../../components/Breadcrumbs';
import { Loading } from '../../components/Loading';
import { useIdParam } from '../../utils/use-id-param.util';
import { Page } from '../../contexts/NavigationContext/enums/page.enum';
import { useNavigationContext } from '../../contexts/NavigationContext/hooks/useNavigationContext.hook';
import { useBuildPath } from '../../hooks/useBuildPath.hook';
import { buildDocumentTitle } from '../../utils/document-title.util';
import { PageTitle } from '../../components/PageTitle';

import { ResolvableServiceTabs } from './Tabs';
import { useFindOneResolvableServiceQuery } from './hooks/useFindOneResolvableServiceQuery.hook';

export const ResolvableServicePage = () => {
  const { setPage } = useNavigationContext();
  const id = useIdParam();

  const path = useBuildPath(PATH_RESOLVABLE_SERVICE_DEFAULT, { id });

  const { data, isSuccess } = useFindOneResolvableServiceQuery(id);

  useEffect(() => {
    setPage(Page.ResolvableServices);
  }, [setPage]);

  const beforeTitleContent = (
    <>
      <Helmet>
        <title>
          {buildDocumentTitle(
            'Fiche Service',
            data?.findOneResolvableService.code,
          )}
        </title>
      </Helmet>
      <Breadcrumbs
        paths={[
          {
            to: PATH_RESOLVABLE_SERVICES,
            label: 'services',
            key: 'resolvableServices',
          },
          {
            to: path,
            label: 'fiche',
            key: 'resolvableService',
          },
        ]}
      />
    </>
  );

  const titleContent = <PageTitle title="Fiche Service" />;

  if (isSuccess) {
    const resolvableService = data.findOneResolvableService;

    return (
      <>
        {beforeTitleContent}
        <PageTitle
          code={resolvableService.code}
          title={resolvableService.label}
        />
        <ResolvableServiceTabs
          resolvableFieldSettings={EMPTY_OBJECT}
          resolvableService={resolvableService}
        />
      </>
    );
  }

  return (
    <>
      <Loading />
      {beforeTitleContent}
      {titleContent}
    </>
  );
};
